import React, { useMemo } from 'react';
import { pickBy, upperCase } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { DateUtils, TypeUtils } from '@vectord/utils';

import { appliedFiltersSelector } from '@courseResume/selectors/coursePauseRequestFilter';
import { COURSE_PAUSE_REQUEST_FILTERS } from '@courseResume/data/coursePauseRequestFilters';
import { removeFilter } from '@courseResume/store/coursePauseRequestFilter';
import styles from './CoursePauseRequestFilterChips.module.scss';
import ToggleChip from 'components/ToggleChip';

function CoursePauseRequestFilterChips() {
  const dispatch = useDispatch();
  const appliedFilters = useSelector(appliedFiltersSelector);

  const filters = useMemo(() => {
    return pickBy(appliedFilters, TypeUtils.isPresent);
  }, [appliedFilters]);

  const handleRemoveFilter = (filterKey) => {
    dispatch(removeFilter(filterKey));
  };

  return Object.keys(filters).map((filterKey) => {
    let label = `${upperCase(filterKey)}: `;

    if (
      filterKey === COURSE_PAUSE_REQUEST_FILTERS.fromToBeResumedDate ||
      filterKey === COURSE_PAUSE_REQUEST_FILTERS.untilToBeResumedDate
    ) {
      label = label + DateUtils.toDDMMMYYYY(filters[filterKey]);
    } else if (filterKey === 'learnerEmail') {
      label = label + filters[filterKey];
    } else {
      label = label + filters[filterKey].label;
    }

    return (
      <ToggleChip
        key={filterKey}
        isAdded
        label={label}
        className={styles.root}
        onRemove={() => handleRemoveFilter(filterKey)}
      />
    );
  });
}

export default CoursePauseRequestFilterChips;
